import { useMemo } from "react";
import { getYandexDirectionUrl, GOOGLE_DIRECTION_URL_CONST } from "../../../../components/StoreLocator";
import { getNaverDirectionUrl } from "../../utils";
export const useDirectionURL = ({ store, locationServiceMapProvider }) => {
    return useMemo(() => {
        if (!store.Location?.lat || !store.Location?.lon)
            return "";
        switch (locationServiceMapProvider) {
            case "google":
                return `${GOOGLE_DIRECTION_URL_CONST}${store.Location.lat},${store.Location.lon}`;
            case "naver":
                return getNaverDirectionUrl(store.ExternalId);
            case "yandex":
                return getYandexDirectionUrl(store);
            default:
                return "";
        }
    }, [store.Location?.lat, store.Location?.lon, store.ExternalId, locationServiceMapProvider]);
};
//# sourceMappingURL=useDirectionUrl.js.map